<template>
  <div id="app" class="common-wrapper">
      <router-view></router-view>
      <!-- 公共模块 -->
      <Tips></Tips>
      <Loding></Loding>
      <isIDPart></isIDPart>
  </div>
</template>

<script>
  import Loding from "@/components/loading.vue";
  import Tips from "@/components/tips.vue";
  import isIDPart from "@/components/idPoup.vue";
  export default {
    name: "App",
    // // 路由发生变化修改页面title
    watch: {
      $route(to, from) {
        if (to.meta.title) {
          document.title = to.meta.title;
        }

        // 销毁滚动条时间防止当前页面事件进入下一个路由时重复加载
        $(window).unbind("scroll");
          this.bus.$emit('loading', false);
      },

    },
    components:{Loding,Tips,isIDPart}
  };
</script>

<style>
  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    font-size: 0.32rem;
  }
  /* 省略号 */
  .ellips {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  button:focus {
    outline: 0;
  }
  .container{
    position: relative;
  }
  /*取消文本框自动填充后变色*/
  input[type='text'] { box-shadow: 0 0 0px 1000px white inset !important;}
  /*取消a标签点击时的颜色*/
  a{
      -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
      -webkit-user-select: none;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue